import { Input } from '@aloft/toolkit-sui';

import { Controller, useFormContext } from 'react-hook-form';

import { Td } from '../table.js';
import { FilterTableFieldName } from './types.js';

export const NumberInput = ({
  name,
  suffix,
  prefix,
}: {
  name: FilterTableFieldName;
  suffix?: string;
  prefix?: string;
}) => {
  const { control } = useFormContext();
  return (
    <Td type="editable" backgroundColor="white" colSpan={2}>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <Input
            id={name}
            size="sm"
            type="number"
            autoFocus
            border="hidden"
            prefix={prefix}
            suffix={suffix}
            borderRadius={0}
            boxShadow="none!important"
            isInvalid={fieldState.invalid}
            onClear={() => {
              field.onChange('');
            }}
            {...field}
          />
        )}
      />
    </Td>
  );
};
